import { triggerAddToCartGTMEvent, triggerRemoveFromCartGTMEvent } from '@bigbasket/gtm';

export function triggerCartGTMEvent({ eventName = '', listType = '', selectedSKU = {} }) {
  const screenInPageContext = listType === 'ms' ? 'beforeyoucheckout' : listType;
  const gtmCartData = {
    list: screenInPageContext,
    products: [
      {
        name: `${selectedSKU?.brand?.name || ''} ${selectedSKU?.description || ''}, ${selectedSKU?.weight || ''} ${selectedSKU?.packDesc || ''}`,
        id: `${selectedSKU.id}` || '',
        price: Number(selectedSKU?.pricing?.discount?.prim_price?.sp) || '',
        brand: selectedSKU?.brand?.name || '',
        category: selectedSKU?.category?.tlc_name || '',
        variant: '',
        quantity: 1,
      },
    ],
  };

  if (['Basket_Add', 'Basket_increment'].includes(eventName)) {
    triggerAddToCartGTMEvent(gtmCartData);
  } else if (Number(selectedSKU?.quantity) === 0 || eventName === 'Basket_decrement') {
    triggerRemoveFromCartGTMEvent(gtmCartData);
  }
}
